import React from 'react';
import { Popper, Autocomplete, Box, Typography, TextField } from '@mui/material';
import { useBookkeeperMentionOptions } from '../../hooks/useBookkeeperMentionOptions';

/**
 * @description Shared component for setting bookkeeper mentions in a message.
 */
const BookkeeperMentions = ({ isOpen, setOpen, anchorEl, onSetMention, isOnModal = false }) => {
  const { data: bookkeeperOptions } = useBookkeeperMentionOptions();

  const handleSetMention = (option) => {
    onSetMention(option);
    setOpen(false);
  };

  return (
    <Popper
      open={isOpen}
      anchorEl={anchorEl}
      placement='bottom-start'
      sx={{
        ...(isOnModal && { zIndex: 1400 }) // Modal z-index is 1300, so use 1400 to be above it
      }}>
      <Autocomplete
        open={isOpen}
        options={bookkeeperOptions}
        getOptionLabel={(option) => option.label}
        onChange={(e, value) => handleSetMention(value)}
        renderOption={(props, option) => (
          <Box {...props} key={option.id} sx={{ padding: 1 }}>
            <Typography>{option.label}</Typography>
          </Box>
        )}
        renderInput={(params) => <TextField {...params} />}
        sx={{ width: 250, backgroundColor: 'white', boxShadow: 2, borderRadius: 1 }}
        slots={{
          popper: (props) => {
            // NOTE: We do this because anchorEl and disablePortal are not valid props and produce a console error unless omitted
            const { disablePortal, anchorEl, ...domProps } = props; // eslint-disable-line no-unused-vars
            return <div {...domProps} style={{ position: 'static' }} />;
          }
        }}
      />
    </Popper>
  );
};

export default BookkeeperMentions;
